export default __webpack_public_path__ + "static/card-syncstage-5x-to-7x-faster-f99630f69f496924641e54177108270e.png";